const initialState = {
  loading: false,
  meetings: null,    // for meetings list if needed
  meeting: null,     // for single meeting detail
  error: null,
};

export const meetingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "START_LOADING":
      return { ...state, loading: true };
    case "STOP_LOADING":
      return { ...state, loading: false };

    case "GET_MEETING_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_MEETING_SUCCESS":
      return { ...state, loading: false, meeting: action.payload, error: null };
    case "GET_MEETING_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "GET_MEETING_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_MEETING_LIST_SUCCESS":
      return { ...state, loading: false, meetings: action.payload, error: null };
    case "GET_MEETING_LIST_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
